import axios from 'axios';

export async function setupCsrfToken() {
    try {
        const response = await axios.get('/getCsrfToken');
        const csrfToken = response.data.csrfToken;

        axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    } catch (error) {
        console.error('Erro ao obter o CSRF Token:', error);
    }
}
